import React from 'react';
import {IndexRoute, Route} from 'react-router';
import {
    App,
    Home,
    About,
    HowItWorks,
    Toolkit,
    Media,
    FundRedirect,
    FundGunInvestments,
    List,
    Compare,
    Family,
    Legal,
    // Resources,
    IndexFunds,
    TargetDateSeries,
    NotFound,
    Companies,
  } from 'containers'

export default (store) => {
  return (
    <Route path="/" component={App}>
      { /* Home (main) route */ }
      <IndexRoute component={Home}/>

      { /* Routes */ }
      <Route path="/funds/:fundId/:investmentVehicleId/:ticker" component={FundRedirect}/>
      <Route path="/funds/:fundId/:investmentVehicleId" component={FundRedirect}/>
      <Route path="/fund/:name/:ticker/gun-investments/:fundId/:investmentVehicleId" component={FundGunInvestments}/>
      <Route path="/funds" component={List}/>
      <Route path="/compare" component={Compare}/>
      <Route path="/families" component={Family}/>
      <Route path="/about" component={About}/>
      <Route path="/how-it-works" component={HowItWorks}/>
      <Route path="/action-toolkit" component={Toolkit}/>
      <Route path="/media" component={Media}/>
      <Route path="/legal" component={Legal}/>
      <Route path="/companies" component={Companies}/>
      <Route path="/index-funds" component={List}/>
      <Route path="/target-date-funds" component={List}/>
      <Route path="/target-date-funds/:strategyName" component={List}/>
      
      { /* Catch all route */ }
      <Route path="*" component={NotFound} status={404} />
    </Route>
  );
};
